import axios from "axios";
import { getEnvVar } from "utils/environment";

const HOST = getEnvVar("HOST");

const api = axios.create({ baseURL: HOST });

export default api;
